import "./App.css";
import React, { useState, useEffect } from "react";
import RightColomn from "./components/RightColomn";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import HomeContent from "./components/HomeContent";
import Login from "./components/Login";
import Officers from "./pages/Officers";
import Profile from "./pages/Profile";
import Events from "./pages/Events";
import EventsAlpha from "./pages/EventsAlpha";
import Meetings from "./pages/Meetings";
import TeacherSearch from "./pages/TeacherSearch";
import McmtaCalendar from "./pages/McmtaCalendar";
import GenerateQrCode from "./components/GenerateQrCode";
import PageNotFound from "./pages/PageNotFound";
import RedirectPage from "./pages/RedirectPage";
import RedirectToExternal from "./components/RedirecToExternal";


function App() {
  const [frameContent, setFrameContent] = useState("");
  const [showComponent, setShowComponent] = useState(false);
  const [menuItems, setMenuItems] = useState({});

  const baseUrl = window.location.origin;
  
  useEffect(() => {
      const toRef = setTimeout(() => {
        setShowComponent(true);
        clearTimeout(toRef);
      }, 10000);
  },[]);

  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route
              path="/"
              element={
                <RightColomn frameContent="">
                  <HomeContent />
                </RightColomn>
              }
            />
            <Route
              path="/content/home.html"
              element={
                <RightColomn frameContent={frameContent}>
                  <HomeContent />
                </RightColomn>
              }
            />
            <Route
              path="/external/msmta.html"
              target="_blank"
              element={
                <RedirectPage location="https://msmta.org/" baseUrl={baseUrl}>
                </RedirectPage>
              }
            />
            <Route
              path="/local/officers"
              element={
                <RightColomn frameContent={""}>
                  <Officers />
                </RightColomn>
              }
            />
            <Route
              path="/local/profile"
              element={
                <RightColomn frameContent={""}>
                  <Profile />
                </RightColomn>
              }
            />
            <Route
              path="/local/meetings"
              element={
                <RightColomn frameContent={""}>
                  <Meetings />
                </RightColomn>
              }
            />
            <Route
              path="/local/calendar"
              element={
                <RightColomn frameContent={""}>
                  <McmtaCalendar />
                </RightColomn>
              }
            />
            <Route
              path="/local/teachersearch"
              element={
                <RightColomn frameContent={""}>
                  <TeacherSearch />
                </RightColomn>
              }
            />
            <Route
              path="/local/events"
              element={
                <RightColomn frameContent={""}>
                  <Events />
                </RightColomn>
              }
            />
            <Route
              path="/local/eventsalpha"
              element={
                <RightColomn frameContent={""}>
                  <EventsAlpha />
                </RightColomn>
              }
            />
            <Route
              path="/local/generateqrcode"
              element={
                <RightColomn frameContent={""}>
                  <GenerateQrCode />
                </RightColomn>
              }
            />
            <Route
              path="/local/login"
              element={
                <RightColomn frameContent={""}>
                  <Login />
                </RightColomn>
              }
            />
            <Route 
              path="/dynamiccontent/:externalContent" 
              element={<RightColomn/>} 
            />
            <Route
              path="/externalcontent/:externalDestination"
              element={<RedirectToExternal/>}
            />
            <Route
              path="*"
              element={
                <RightColomn frameContent={""}>
                  <PageNotFound />
                </RightColomn>
              }
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
